import React from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Typography from "@mui/material/Typography";
import { Chip } from "@mui/material";
import axios from "axios";

const Card = () => {
  return (
    <>
      <div
        className={
          "relative w-full overflow-hidden bg-white box-shadow-request-card grid grid-cols-4 rounded-lg my-4 p-2"
        }
      >
        {/* Accepted */}
        <div
          className="absolute bg-gray-500/50 ring-8 ring-green-500 ring-inset h-full w-full overflow-hidden unshow"
          id="accepted"
        >
          <div className="flex justify-center items-center h-full ">
            <div className="px-4 py-2 bg-green-500 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Accepted
              </Typography>
            </div>
          </div>
        </div>
        {/* Declined */}
        <div
          className="absolute bg-gray-500/50 ring-8 ring-red-600 ring-inset h-full w-full overflow-hidden unshow"
          id="decline"
        >
          <div className="flex justify-center items-center h-full">
            <div className="px-4 py-2 bg-red-600 rounded-md">
              <Typography variant="h4" component="h4" sx={{ color: "white" }}>
                Declined
              </Typography>
            </div>
          </div>
        </div>
        {/* -------- */}

        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Received 15 Min ago</p>
        </div>
        <div className="border-r border-gray-400 my-auto col-span-1">
          <img
            src={require("../../../images/photo.png")}
            className="h-32 rounded-full border-2 border-black p-1 block mx-auto"
            alt="Profile"
          />
          <button className="view-profile-card-btn w-4/5 mt-2 mx-auto">
            View Profile
          </button>
        </div>
        <div className="px-3 col-span-3">
          <div className="flex py-1 justify-between w-full">
            <div className="flex gap-x-2">
              <div className="w-12 h-12 logo-shadow mx-1 rounded-lg">
                <img src={require("../../../images/iitd.png")} alt="google" />
              </div>
              <div>
                <h4 className="text-2xl text-left font-medium leading-6">
                  John Doe
                </h4>
                <p>IIT Bhilai</p>
              </div>
            </div>
            <div className="flex gap-2">
              <div className="flex justify-center h-10 text-blue-500 text-2xl">
                <Button variant="contained">
                  <i className="fa-solid fa-link mr-1"></i> Resume
                </Button>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                <i className="fa-solid fa-bookmark"></i>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                <i className="fa-solid fa-share"></i>
              </div>
            </div>
          </div>
          <div
            className="flex justify-between text-center my-1 gap-x-1 mx-2"
            style={{ alignItems: "flex-start" }}
          >
            <div>
              <p className="text-base text-gray-400">Profile</p>
              <Chip
                label="Banking and Finance"
                color="info"
                sx={{ fontWeight: "medium" }}
              />
            </div>
            <div>
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">INR 1200</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Session Duration</p>
              <p className="text-lg">45 Min</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Interview Slot</p>
              <p className="text-lg">[12:00 PM - 12:30PM]</p>
              <p className="text-lg">20 June, 2022</p>
            </div>
          </div>
          <div className="flex justify-center">
            <Button
              variant="contained"
              sx={{ backgroundColor: "green", marginRight: "10px" }}
            >
              Accept
            </Button>
            <Button variant="contained" sx={{ backgroundColor: "red" }}>
              Decline
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
